
<div class="menu" style="text-align: center;">
  <div class="second-row" style="flex-grow: unset; width: 32vw; margin: auto;">
    <h2 style="margin-bottom: 36px;">Unsupported Browser</h2>
    <p>The GraphOn Customer Portal does not support Internet Explorer at this time.  Please use another modern browser,
      such as Chrome, Firefox, Safari, or Microsoft Edge to access the portal.
    </p>
  </div>
</div>
